import script from "./CoacheEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./CoacheEdit.vue?vue&type=script&setup=true&lang=js"

import "./CoacheEdit.vue?vue&type=style&index=0&id=0e936364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e936364"]])

export default __exports__